import React, {memo} from 'react';

import {Box, Typography} from '@mui/material';

import {AlertIcon} from '@/app/icons';
import './styles';

export enum NoteType {
  ALERT = 'ALERT',
}

interface NoteProps {
  text: string;
  type: NoteType;
  className?: string;
}

const NoteComponent = ({text, type, className}: NoteProps) => {
  const typeClassName = type.toLowerCase();
  const noteClassName = [
    'note-component',
    `note-component--${typeClassName}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Box className={noteClassName}>
      <AlertIcon
        width={20}
        height={20}
      />
      <Typography className="note-component-text">{text}</Typography>
    </Box>
  );
};

export const Note = memo(NoteComponent);
